import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";

import styles from "./QRCodeGenerator.module.scss";

interface QRCodeGeneratorProps {
  url: string;
  size?: number;
  bgColor?: string;
  fgColor?: string;
}

export const QRCodeGenerator: React.FC<QRCodeGeneratorProps> = ({
  url,
  size = 215,
  bgColor = "#ffffff",
  fgColor = "#000000",
}) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e: React.MouseEvent) => {
    setPosition({
      x: e.clientX,
      y: e.clientY,
    });
  };

  return (
    <>
      <div
        className={styles.container}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onMouseMove={handleMouseMove}
      >
        <QRCodeSVG
          value={url}
          size={size}
          bgColor={bgColor}
          fgColor={fgColor}
        />
      </div>

      {visible && (
        <div
          className={styles.tooltip}
          style={{
            left: position.x + 12,
            top: position.y - 12,
          }}
        >
          {url}
        </div>
      )}
    </>
  );
};

export default QRCodeGenerator;
